import get from "lodash/get";
import { Tdata } from "../types";

export const checkLimitsCellValue = (el: Tdata, path: string): number => {
    const cellValue = get(el, path);
    if (cellValue === undefined) return -1;
    return cellValue;
  };